/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, zip } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import * as fromStore from 'app/shared/store';
import * as fromEventsStore from 'app/events/store';
import { Constants } from '../models/constants.model';
import { EventDetailsService } from 'app/events/services/event-details.service';

@Injectable()
export class FullAccessGuard implements CanActivate {
  private eventId;
  constructor(
    private store: Store<fromStore.SharedState>,
    private eventStore: Store<fromEventsStore.EventsState>,
    private eventDetailsService: EventDetailsService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.eventId = parseInt(route.parent.params.id);
    return this.checkStore();
  }

  checkStore(): Observable<any> {
    const eventDetails = this.eventDetailsService.getEventById({ id: this.eventId });

    const userDetails = this.store.select(fromStore.getUser).pipe(filter(userData => userData.id));

    const userProducts = this.store.select(fromStore.getAccessState).pipe(
      filter((accessState) => !accessState.loading && accessState.success),
      map((accessState) => accessState.products));

    return zip(userDetails, eventDetails, userProducts).pipe(
      map(([userData, eventData, accessProducts]) => {
        if (
          userData &&
          (userData.type === Constants.USER_TYPE.ADMIN || userData.type === Constants.USER_TYPE.HEAD_COACH)
        ) {
          return true;
        }
        if (eventData && eventData.channel && eventData.channel.id) {
          const channelId = eventData.channel.id;
          return !!accessProducts.find(
            p => (p.type === Constants.PURCHASE_TYPE.CHANNEL_GF && p.channelId === channelId && p.metadata && p.metadata.fullAccess)
          );
        }

        return false;
      })
    );
  }
}
